import { httpClient } from "@/services";

export default {
	state: {
		loads: '',
		spotRate: false,
		chart: {
			date: [],
			amount: [],
			mileage: []
		},
		totalData: {
			totalLoad: '',
			totalAmount: '',
			truck: ''
		},
		dataTooltips: [],
		showMarker: false,
		ratesData: []
	},
	mutations: {
		SET_LOADS(state, { load, rateAverage, total_load, amount, total_truck, graph, spot_rate }) {
			state.loads = load;
			state.ratesData = rateAverage;
			state.spotRate = spot_rate;
			state.totalData = {
				totalLoad: total_load,
				totalAmount: amount,
				truck: total_truck
			};

			state.chart = { date: [], amount: [], mileage: [] };

			for (const keyGraph in graph) {
				const { amount, mileage } = graph[keyGraph];

				state.chart.date.push(keyGraph);
				state.chart.amount.push(amount);
				state.chart.mileage.push(mileage);
			}
		}
	},
	actions: {
		async getLoad({ commit }, values) {
			try {
				const { data } = await httpClient.post('/graph', values);
				if (data) {
					commit('SET_LOADS', data);
				}
				return data;
			} catch (error) {
				return error;
			}
		}
	},
	getters: {
		spotRate: s => s.spotRate,
		ratesData: s => s.ratesData,
		getTotal: s => s.totalData,
		getFilters: s => s.filters
	}
};
